import moment from "moment";

const DATE_KEY = "YYYY-MM-DD";

/**
 * HO-TASK-292: la fecha cuya tasa aplica a un día.
 *
 * El BCV no publica sábado ni domingo, y lo que publica durante el fin de
 * semana es la tasa que entra en vigencia el lunes. Así que un sábado o un
 * domingo usan la tasa del lunes siguiente; un día hábil usa la suya.
 *
 * El backend aplica la misma regla y, al consultar la tasa oficial de una
 * fecha, devuelve el día que le corresponde en `effective_date`. Acá se repite
 * porque los formularios resuelven la tasa contra el listado que ya tienen en
 * memoria, sin volver a preguntarle a la API: sin esta regla buscarían una
 * tasa de sábado, que ya no existe, y terminarían registrando una.
 */
export const rateEffectiveDateKey = (date) => {
  if (!date) return null;

  const parsed = moment(date);

  if (!parsed.isValid()) return null;

  // moment().day(): 0 es domingo y 6 es sábado.
  const weekday = parsed.day();

  if (weekday === 6) return parsed.clone().add(2, "days").format(DATE_KEY);
  if (weekday === 0) return parsed.clone().add(1, "days").format(DATE_KEY);

  return parsed.format(DATE_KEY);
};

export const isWeekendDate = (date) => {
  if (!date) return false;

  const parsed = moment(date);

  if (!parsed.isValid()) return false;

  return parsed.day() === 6 || parsed.day() === 0;
};

export default rateEffectiveDateKey;
